// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[v-cloak][data-v-149dc8fa] {\n\tdisplay: none;\n}\nh6[data-v-149dc8fa] {\n\tfont-size: 0.7rem;\n\tcolor: #737373;\n}\n.grid-row[data-v-149dc8fa] {\n\tdisplay: grid;\n\tgrid-template-columns: 8fr 4fr;\n\talign-items: center;\n}\n.controls[data-v-149dc8fa] {\n\tdisplay: grid;\n\tgrid-template-columns: 1fr 1fr;\n}\n\n", ""]);
// Exports
module.exports = exports;
